module.exports = __webpack_public_path__ + "img/ElectricNormal.bdc59f66.svg";